"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _order = require("@/api/order");
var _auth = require("@/utils/auth");
var _default = exports.default = {
  components: {},
  props: {
    isChildren: {
      default: false
    },
    isheadr: {
      default: false
    }
  },
  data: function data() {
    return {
      //校验必填项
      dialogRules: {
        projectid: [{
          required: true,
          message: "请选择项目",
          trigger: "blur"
        }],
        orderType: [{
          required: true,
          message: "请选择工单类型",
          trigger: "blur"
        }],
        dealUser: [{
          required: true,
          message: "请选择处理人",
          trigger: "blur"
        }]
      },
      dialogImageUrl: "",
      //预览图片的url
      dialogVisible: false,
      //是否显示预览图片组件
      imageFileList: [],
      //选中的图片文件数组
      orderModel: {
        // 新建工单需要的参数
        projectid: null,
        orderType: "1",
        dealUser: null,
        sendUsers: [],
        desc: "",
        uploadFiles: []
      },
      projectList: [],
      // 项目列表
      projectUserList: [] //项目用户列表
    };
  },
  computed: {},
  created: function created() {
    this.getProjectData();
  },
  mounted: function mounted() {},
  methods: {
    //点击了返回按钮
    handleBack: function handleBack() {
      if (this.isChildren) {
        this.$emit("change", false);
      } else {
        this.$router.go(-1);
      }
    },
    // 获取项目列表
    getProjectData: function getProjectData() {
      var _this = this;
      (0, _order.getProject)().then(function (res) {
        _this.projectList = res;
      });
    },
    // 选中的项目发生了变化 获取用户
    selectProjectHaveChange: function selectProjectHaveChange(value) {
      //console.log("selectProjectHaveChange");
      this.getProjectUserList();
    },
    // 获取项目关联的用户列表
    getProjectUserList: function getProjectUserList() {
      var _this2 = this;
      var projectid = this.orderModel.projectid;
      var par = {
        projectId: projectid
      };
      (0, _order.getuserInfoByProjectId)(par).then(function (res) {
        _this2.projectUserList = res.filter(function (item) {
          return item.id != (0, _auth.getUserId)();
        });
      });
    },
    // el组件关联图片上传时事件
    imageUpload: function () {
      var _imageUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(file) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              //console.log("imageUpload:", file);
              this.imageFileList.push(file.file);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function imageUpload(_x) {
        return _imageUpload.apply(this, arguments);
      }
      return imageUpload;
    }(),
    // 图片超出范围时
    handleExceed: function handleExceed(file, flies) {
      this.$message.warning("最多只能上传10张");
    },
    // 点击了预览图片
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // el组件图片上传之前
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 10MB!",
          type: "warning"
        });
      }
      return isLt2M;
    },
    // 创建工单
    createOrderAction: function createOrderAction() {
      var _this3 = this;
      this.$refs["dialogForm"].validate(function (valid) {
        if (valid) {
          _this3.creatOrderRequest();
        }
      });
    },
    // 创建工单的异步请求
    creatOrderRequest: function () {
      var _creatOrderRequest = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this4 = this;
        var i, file, par;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.orderModel.uploadFiles = [];
              this.$refs.elUpload.submit();
              //先提交图片
              i = 0;
            case 3:
              if (!(i < this.imageFileList.length)) {
                _context2.next = 10;
                break;
              }
              file = this.imageFileList[i];
              _context2.next = 7;
              return this.uploadImage(file);
            case 7:
              i++;
              _context2.next = 3;
              break;
            case 10:
              par = {
                eventDescription: this.orderModel.desc,
                projectId: this.orderModel.projectid,
                workOrderSendUsers: this.orderModel.sendUsers,
                workOrderType: this.orderModel.orderType,
                reviewerId: this.orderModel.dealUser,
                workOrderStatus: 0,
                submitterId: (0, _auth.getUserId)(),
                multipartFiles: this.orderModel.uploadFiles
              };
              (0, _order.postInsertProjectWordOrder)(par).then(function (res) {
                //console.log("postInsertProjectWordOrder:", res);
                if (res == null) {
                  _this4.$message.success("创建成功");
                  if (_this4.isChildren) {
                    _this4.$emit("change", true);
                  } else {
                    sessionStorage.setItem("routerIndex", 0);
                    _this4.$router.go(-1);
                  }
                }
              });
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function creatOrderRequest() {
        return _creatOrderRequest.apply(this, arguments);
      }
      return creatOrderRequest;
    }(),
    //上传图片 异步
    uploadImage: function () {
      var _uploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3(file) {
        var _this5 = this;
        var tmp;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              tmp = new FormData();
              tmp.append("multipartFile", file);
              _context3.next = 4;
              return (0, _order.postUploadImage)(tmp).then(function (res) {
                if (res) {
                  _this5.orderModel.uploadFiles.push(res);
                }
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function uploadImage(_x2) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }()
  }
};